import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorageItem } from "../Utils";
import Layout from "../Layout/Layout";
import { useShouldUseLayout } from "./UseLayoutRoutes";

function ProtectedAuth() {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("isLoggedIn");
    // const user = true;
    return user;
  };

  const shouldUseLayout = useShouldUseLayout();

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  return shouldUseLayout ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Outlet />
  );
}

export default ProtectedAuth;
